import { Typography } from "@material-ui/core";
import { DateTime } from "luxon";

import useStyles from "./HoverImage.styles";


export interface HoverImageProps {
    url?: string;
    datetime: DateTime;
    thumbnailBoundingBox: DOMRect;
}

export const HoverImage = (props: HoverImageProps) => {
    const { url, datetime } = props;
    const classes = useStyles(props);


    return (
        <div className={classes.hoverImage}>
            {url && <img src={url} alt="" />}
            <span className={classes.hoverDateTime}>
                <Typography variant="body1">
                    {`${datetime.toLocaleString(
                        DateTime.DATE_FULL,
                    )} \u2022 ${datetime.toLocaleString(DateTime.TIME_WITH_SHORT_OFFSET)}`}
                    {/* or just TIME_SIMPLE */}
                </Typography>
            </span>
        </div>
    );
};
